var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Laos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M40.695,35H7.305c3.578,5.419,9.715,9,16.695,9S37.117,40.419,40.695,35z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M24,4c-6.98,0-13.117,3.581-16.695,9h33.39C37.117,7.581,30.98,4,24,4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M44,24c0-4.066-1.221-7.843-3.305-11H7.305C5.221,16.157,4,19.934,4,24s1.221,7.843,3.305,11h33.39 C42.779,31.843,44,28.066,44,24z M24,32c-4.417,0-8-3.583-8-8c0-4.417,3.583-8,8-8s8,3.583,8,8C32,28.417,28.417,32,24,32z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 8,
    fill: "#eceff1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Laos);
export default __webpack_public_path__ + "static/media/icons8-laos.f9b4f306927fdee1b806d58c1c0946c6.svg";
export { ForwardRef as ReactComponent };